import { render, staticRenderFns } from "./page-header-mobile.vue?vue&type=template&id=768269ae&scoped=true"
import script from "./page-header-mobile.vue?vue&type=script&lang=js"
export * from "./page-header-mobile.vue?vue&type=script&lang=js"
import style0 from "./page-header-mobile.vue?vue&type=style&index=0&id=768269ae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768269ae",
  null
  
)

export default component.exports